var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apexchart',{attrs:{"type":"donut","height":"300","options":_vm.options,"series":_vm.series.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }